exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PopularLocationGrid-GridCollapse-WrDTg {\n\tposition: relative;\n}\n\n.PopularLocationGrid-containerTitle-mwQ1b {\n\tcolor: var(--common-text-color);\n\tline-height: normal;\n\tmargin: 0 0 45px;\n\tpadding: 0px 15px;\n\tfont-weight: bold;\n\tfont-size: 32px;\n\t-webkit-transition: all .4s ease-out;\n\ttransition: all .4s ease-out;\n}\n\n.PopularLocationGrid-noLeftPadding-Htem2 {\n\tpadding: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.PopularLocationGrid-marginLeft-tIdFv {\n\t\tmargin: 0 0 24px 34px;\n\t}\n\n\t.PopularLocationGrid-containerTitle-mwQ1b {\n\t\tmargin: 0 0 40px;\n\t}\n}", ""]);

// exports
exports.locals = {
	"GridCollapse": "PopularLocationGrid-GridCollapse-WrDTg",
	"containerTitle": "PopularLocationGrid-containerTitle-mwQ1b",
	"noLeftPadding": "PopularLocationGrid-noLeftPadding-Htem2",
	"marginLeft": "PopularLocationGrid-marginLeft-tIdFv"
};